import React, { Component } from 'react';
import { Helmet } from "react-helmet"


import './Header.scss'
import Wave from '../Components/Wave'
import hexToRgba from "hex-to-rgba"


class Header extends Component {
	componentDidMount() {
		window.scrollTo(0,0);
	}
	render() {
		return (
			<div>
					<Helmet>
						<title>{this.props.seoTitle || this.props.title || "Title not found"}</title>
					</Helmet>  
					<div
					className={`page-header ${this.props.image ? "custom-background" : ""}`} style={this.props.image ? { backgroundImage: `url(${this.props.image})` } : {}}>
					{this.props.video ? <video autoPlay loop muted playsInline  >
						{this.props.video.webm ? <source src={this.props.video.webm} type="video/webm" /> : null}
						{this.props.video.mp4 ? <source src={this.props.video.mp4} type="video/mp4" /> : null}
						{this.props.video.ogv ? <source src={this.props.video.ogv} type="video/ogv" /> : null}
					</video> : null}
					<div className="color-bg"
						style={this.props.bg === "none" ? { background: 'transparent' } : this.props.bg ? { background: `linear-gradient(to top, ${hexToRgba(this.props.bg, 0.25)},${hexToRgba(this.props.bg, 0.75)}, ${hexToRgba(this.props.bg, 0.9)})` } : null}
					></div>
					<h1>{this.props.title}</h1>
					<Wave className={`page`} />
				</div>
			</div>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/Layout/Header.js